import * as React from 'react';
import { Dialog } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import { traducirButton, traducirLabel } from '../../blocks/traductor';

interface Props {
    titulo: string
    contenido: string
    abierto: boolean
    cerrar: () => void
    maxWidth?: 'lg' | 'md' | 'sm' | 'xl'
}

const AyudaDialog = ({ titulo, contenido, abierto, cerrar, maxWidth }: Props) => {
    return (<>
        <Dialog open={abierto} maxWidth={maxWidth ? maxWidth : "sm"} fullWidth={true} onClose={cerrar}>
            <DialogTitle id="simple-dialog-title">{titulo}</DialogTitle>
            <DialogContent dividers>
                <DialogContentText>
                    <div className="content" dangerouslySetInnerHTML={{__html: (contenido)}}></div>
                        {/*contenido*/}
                
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={cerrar} color="primary">
                    {traducirButton(16)}
                </Button>
            </DialogActions>
        </Dialog>
    </>)
};

export default AyudaDialog;
